import {ErrorHandler, LOCALE_ID, NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {WebLayoutModule} from "@app-web-central/web/shell/ui/layout";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {RouterModule} from "@angular/router";
import {TranslateLoader, TranslateModule} from "@ngx-translate/core";
import {HttpClient} from "@angular/common/http";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {NgIdleKeepaliveModule} from "@ng-idle/keepalive";
import {extModules} from "./build-specifics";
import {CookieService} from "ngx-cookie-service";
import * as Sentry from "@sentry/angular";
import {en_US, fr_FR, NZ_I18N} from "ng-zorro-antd/i18n";
import {webAdminRoutes} from "./web-admin-routes";

/** Languages / i18n **/
import {registerLocaleData} from '@angular/common';
import en from '@angular/common/locales/en';
import fr from '@angular/common/locales/fr';
import {WebSharedModule} from "./web-shared.module";
registerLocaleData(en);
registerLocaleData(fr);

@NgModule({
  imports: [
    CommonModule,
    WebLayoutModule,
    WebSharedModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(webAdminRoutes),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) => {
          return new TranslateHttpLoader(http);
        },
        deps: [HttpClient]
      },
      isolate: true
    }),
    NgIdleKeepaliveModule.forRoot(),
    ...extModules
  ],
  exports: [
    RouterModule
  ],
  providers: [
    CookieService,
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: true,
        dialogOptions: {lang: 'fr'}
      })
    },
    {
      provide: NZ_I18N,
      useFactory: (localId: string) => {
        switch (localId) {
          case 'en':
            return en_US;
          case 'fr':
            return fr_FR;
          default:
            return en_US;
        }
      },
      deps: [LOCALE_ID]
    },
  ]
})
export class WebAdminModule {

}
